import { Controller, Loader, IDynamicLoader } from '@tencent/workbench';
import { FORM_CONFIGS } from './config';
import { Form } from '@tencent/wb-ext-form';
import { FormItemName } from '@framework/workbench/drawer/constants';
import { IPlaceholderFormatFeature } from './pl-format-interface';
import { ReactElement } from 'react';

@Controller({ formItems: FORM_CONFIGS })
export class PlaceholderFormatController {
    constructor(@Loader(IPlaceholderFormatFeature) private loader: IDynamicLoader<IPlaceholderFormatFeature>) {}

    private get feature() {
        return this.loader.instance!;
    }

    @Form(FormItemName.PLACEHOLDER_FORMAT, 'content')
    public placeholderFormatContent(): ReactElement {
        return this.feature.getPlaceholderFormatContent();
    }
}
